import React from 'react';
import { OverviewSection } from '@common/components/overview';
import LearningModule from '../learning-module';
import { ModuleItemProps } from '../types';

const ModuleItem: React.FC<ModuleItemProps> = ({
  module,
  index,
  onDeleteModule,
  onDeleteLesson,
  onUpdateModule,
  onUpdateLesson,
}) => {
  return (
    <OverviewSection className="!tw-border-gray-border tw-pb-4">
      <LearningModule
        title={module.title}
        duration={module.duration}
        screens={module.screens}
        lessons={module.lessons}
        onDeleteModule={() => onDeleteModule(index)}
        onDeleteLesson={(lessonIndex) => onDeleteLesson(index, lessonIndex)}
        onUpdateModule={(newTitle) => onUpdateModule(index, newTitle)}
        onUpdateLesson={(lessonIndex, updatedLesson) => onUpdateLesson(index, lessonIndex, updatedLesson)}
      />
    </OverviewSection>
  );
};

export default ModuleItem;
